import api from '@/utils/api'

export default {
    getMatches(page, size, query) {
        let filter = null
        if (Object.values(query).length > 0) {
            filter = Object.values(query).reduce((total, value) => total + `, ${value}`)
        }
        const range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get('matches' + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(filter)}` : ''))
    },

    getMatchesByTeam(id, query, phase) {
        const params = []

        if (phase === 'cup') {
            params.push('isCup=true')
        } else if (phase) {
            params.push(`phase=${encodeURIComponent(phase)}`)
            params.push('isCup=false')
        }

        if (query && Object.values(query).length > 0) {
            Object.values(query).forEach(value => {
                params.push(String(value))
            })
        }

        const queryParams = params.length ? `?${params.join('&')}` : ''
        return api.get(`matches/team/${id}${queryParams}`)
    },

    getMatch(id) {
        return api.get(`matches/${id}/stats`)
    },

    // The list entry of one match: status (pending / postponed), arena and round label, which the stats endpoint lacks
    getMatchSummary(id) {
        return this.getMatches(1, 1, { query: `{"id":"${id}"}` }).then(resp => (resp.data.content || [])[0] || null)
    },

    getMatchLogs(matchId) {
        return api.get(`matches/${matchId}/logs`)
    },

    getActivePlayers(matchId) {
        return api.get(`matches/${matchId}/active-players`)
    },

    // The live stream page tells the stats operator (CMS) which screen it shows
    reportLiveScreen(matchId, screen) {
        return api.post(`events/${matchId}/screen-state`, { screen })
    }
}
